import { customMedia } from '@mollie/ui-tokens';
import { useEffect, useState } from 'react';
import { useMatchMediaManagerContext } from '../components/MatchMediaManager/MatchMediaManagerContext';
export const watchMedia = Object.keys(customMedia).reduce((listeners, key) => {
    if (typeof window === 'undefined' ||
        typeof window.matchMedia === 'undefined') {
        return listeners;
    }
    listeners[key] = window.matchMedia(Number(customMedia[key].max) < Infinity
        ? `(min-width: ${customMedia[key].min}) and (max-width: ${customMedia[key].max})`
        : `(min-width: ${customMedia[key].min})`);
    if (key !== 'extra-large') {
        listeners[`to-${key}`] = window.matchMedia(`(max-width: ${customMedia[key].to})`);
    }
    if (key !== 'extra-large') {
        listeners[`from-${key}`] = window.matchMedia(`(min-width: ${customMedia[key].from})`);
    }
    return listeners;
}, {});
export function useMatchMedia(viewport) {
    var _a;
    const [matchedMedia, setMatchedMedia] = useState(() => { var _a; return (_a = watchMedia[viewport]) === null || _a === void 0 ? void 0 : _a.matches; });
    const ctxMatchedMedia = useMatchMediaManagerContext();
    useEffect(() => {
        if (ctxMatchedMedia !== null) {
            return;
        }
        const matchMedia = watchMedia[viewport];
        const queryMatchedMedia = (mql) => {
            setMatchedMedia(mql.matches);
        };
        if (matchMedia.addEventListener) {
            matchMedia.addEventListener('change', queryMatchedMedia);
        }
        else if (matchMedia.addListener) {
            matchMedia.addListener(queryMatchedMedia);
        }
        return () => {
            if (matchMedia.removeEventListener) {
                matchMedia.removeEventListener('change', queryMatchedMedia);
            }
            else if (matchMedia.removeListener) {
                matchMedia.removeListener(queryMatchedMedia);
            }
        };
    }, [viewport, ctxMatchedMedia]);
    return (_a = ctxMatchedMedia === null || ctxMatchedMedia === void 0 ? void 0 : ctxMatchedMedia[viewport]) !== null && _a !== void 0 ? _a : matchedMedia;
}
//# sourceMappingURL=useMatchMedia.js.map